import React, { memo, useContext } from 'react';
import { number } from 'prop-types';
import classNames from 'classnames/bind';

import { StaticTextContext } from 'context/StaticTextContext';
import { SearchContext } from 'context/SearchContext';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import { getCurrentTab } from 'utils/tabsHelper';

import styles from './ResultsListInfo.module.scss';
const cx = classNames.bind(styles);

const ResultsListInfo = ({ itemsNumber }) => {
  const {
    labels: {
      searchResultsSearchItemText,
      searchResultsInfoText,
      searchResultInfoText,
    },
  } = useContext(StaticTextContext);
  const { searchCarQuery } = useContext(SearchContext);
  const currentTab = getCurrentTab();
  const isVinTab = currentTab === 'vin' || currentTab === 'kba';
  const isCarTab = currentTab === 'car';
  const searchText =
    itemsNumber > 1 ? searchResultsInfoText : searchResultInfoText;

  if (!itemsNumber) {
    return null;
  }

  return (
    <div className={cx('results-info', isCarTab)}>
      {!!searchCarQuery && isVinTab && (
        <div className={cx('search-item')}>
          <span className={cx('bold')}>{searchResultsSearchItemText}:</span>
          {' ' + searchCarQuery}
        </div>
      )}
      <div className={cx('results-number')}>
        {itemsNumber}&nbsp;{searchText}
      </div>
    </div>
  );
};

ResultsListInfo.propTypes = {
  itemsNumber: number,
};

ResultsListInfo.defaultProps = {
  itemsNumber: null,
};

export default memo(withErrorBoundary(ResultsListInfo));



// WEBPACK FOOTER //
// ./src/components/ResultsListInfo/ResultsListInfo.js